import {components} from "react-select";
import React from "react";

const Option = props => {
    return (
        <components.Option {...props} />
    );
};

export default Option;